module.exports = __webpack_public_path__ + "static/media/registration-drop-down-icon.821e41c9.svg";